import { gql, useQuery } from '@apollo/client';

const NOTIFICATIONS_QUERY = gql`
  query userNotification($todayDate: Timestamptz!) {
  userPushNotifications(
    order_by: {notification: {createdAt: Desc}}
    where: {notification: {notifyTo: {_eq: "learner"}}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
  }
  olderNotifications: userPushNotifications(
    where: {notification: {notifyTo: {_eq: "learner"}, createdAt: {_lt: $todayDate}}}
    order_by: {notification: {createdAt: Desc}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
  }
  todaysNotifications: userPushNotifications(
    where: {notification: {notifyTo: {_eq: "learner"}, createdAt: {_gte: $todayDate}}}
    order_by: {notification: {createdAt: Desc}}
  ) {
    notification {
      message
      title
      createdAt
    }
    id
    readStatus
      }
    }
`

const useNotifications = () => {
  const { data, loading, error, refetch } = useQuery(NOTIFICATIONS_QUERY, {
    variables: { todayDate: new Date().toLocaleDateString('en-IN').split('/').reverse().join('-') },
    context: {
      headers: {
        'x-hasura-role': 'learner'
      }
    }
  });
  return { data, loading, error, refetch };
}

export { useNotifications };